import { render, staticRenderFns } from "./contactLabels.vue?vue&type=template&id=3f7d71ac&scoped=true&"
import script from "./contactLabels.vue?vue&type=script&lang=ts&"
export * from "./contactLabels.vue?vue&type=script&lang=ts&"
import style0 from "./contactLabels.vue?vue&type=style&index=0&id=3f7d71ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d71ac",
  null
  
)

export default component.exports